import urllib from 'url-lib';
import { initialize } from 'redux-form';
import { has, isEmpty } from 'lodash';

import { SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK } from '@eb/social-login-facebook';
import {
    LOOK_UP_FORM,
    SOCIAL_SIGN_UP_FORM,
    BASE_URL,
    PASSWORD_SET_TOKEN,
    INVALID_RESET_TOKEN,
    SET_PASSWORD_FORM,
    GA_SET_PASSWORD_EVENT,
    GA_RESET_PASSWORD_EVENT,
    RESET_PASSWORD_PATH,
    TRIGGER_RESET_PASSWORD,
} from './constants';

export const getSetPasswordFormType = (routeFormType, query) =>
    !has(query, PASSWORD_SET_TOKEN) ? TRIGGER_RESET_PASSWORD : routeFormType;

export const normalizePath = (path) => `/${path.replace(/\//g, '')}`;

/*
    This function acts as a gateway to ensure that the user has had their
    email status checked before accessing /login or /signup forms specifically.

    They can access these potentially with corrupted email states if navigating
    back and forward with the browser while modifying the email held
    within the form.
*/
export const accountStatusChecked = ({ getState }, replace) => {
    const { authentication: { isAccountStatusChecked } = {} } = getState();

    /*
     * If email does not exist within the store redirect to start of the
     * signin flow (they arrived via direct route or refresh)
     */

    if (!isAccountStatusChecked) {
        replace(BASE_URL);
    }
};

export const checkEmailExists = ({ getState }, replace) => {
    const { authentication: { email } = '' } = getState();

    /*
     * If email was not provided, return to login page.
     * It does not check whether the e-mail is confirmed or not
     * Only that it's provided
     */
    if (!email) {
        replace(BASE_URL);
    }
};

/**
 * Every time we return to /signin we want to re-initialize the form
 * so that error states are cleared etc.
 */
export const setUpForm = ({ getState, dispatch }) => {
    const {
        authentication: { email, shouldIncludeEmailConfirmation } = {},
    } = getState();

    if (shouldIncludeEmailConfirmation) {
        // Avoid to set email as part of our experiment
        dispatch(initialize(LOOK_UP_FORM));
    } else if (email) {
        dispatch(initialize(LOOK_UP_FORM, { email }));
    }
};

export const setUpSocialForm = ({ getState, dispatch }, replace) => {
    const {
        authentication: {
            socialData: { firstName, lastName, email },
        },
    } = getState();

    // If there's no email, go back to the first step in the flow
    if (!email) {
        replace(BASE_URL);
    }

    dispatch(initialize(SOCIAL_SIGN_UP_FORM, { email, firstName, lastName }));
};

export const checkPasswordReset = ({ dispatch }, query, replace) => {
    if (has(query, INVALID_RESET_TOKEN)) {
        replace(
            urllib.formatUrl(BASE_URL, {
                [INVALID_RESET_TOKEN]: 1,
            }),
        );
    } else if (has(query, PASSWORD_SET_TOKEN)) {
        dispatch(
            initialize(SET_PASSWORD_FORM, {
                [PASSWORD_SET_TOKEN]: query[PASSWORD_SET_TOKEN],
            }),
        );
    } else if (has(query, 'email')) {
        dispatch(initialize(LOOK_UP_FORM, { email: query.email }));
    }
};

export const isFacebookLoginEnabled = (socialSSOSettings) =>
    !isEmpty(socialSSOSettings) &&
    !isEmpty(socialSSOSettings[SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK]);

export const isLoginProviderEnabled = (socialSSOSettings, provider) =>
    !isEmpty(socialSSOSettings) && !isEmpty(socialSSOSettings[provider]);

/*********************** GA TRACKING UTILS ***********************/
//Helper to determine if action should be ResetPassword or SetPassword
//The only determining factor is the current route as the same form
//is rendered in either case.
export const getSetPasswordEvent = (currentRoute) => {
    let event = GA_SET_PASSWORD_EVENT;

    if (currentRoute.indexOf(RESET_PASSWORD_PATH) > -1) {
        event = GA_RESET_PASSWORD_EVENT;
    }

    return event;
};
